import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import Stack from '@mui/material/Stack';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import LocalGasStationOutlinedIcon from '@mui/icons-material/LocalGasStationOutlined';
import CloudOutlinedIcon from '@mui/icons-material/CloudOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import {IServiceRent} from '../interfaces/KKM/IServiceRent';
import {EServiceRent} from '../Enums/ServiceRent';
import {IServiceSign} from '../interfaces/KKM/IServiceSign';
import {EServiceSign} from '../Enums/ServiceSign';

interface ServiceRentIconProps {
    kkm: {
        service_rent: IServiceRent[];
        service_sign: IServiceSign[];
    };
}

const ServiceRentIcon: React.FC<ServiceRentIconProps> = ({kkm}) => {
    const rentBase = kkm.service_rent.find(item => item.service_rent_id === EServiceRent.Base);
    const rentNomenclature = kkm.service_rent.find(item => item.service_rent_id === EServiceRent.Nomenclature);
    const rentPremiumOFD = kkm.service_rent.find(item => item.service_rent_id === EServiceRent.PremiumOFD);
    const gasStation = kkm.service_sign.find(item => item.service_sign_id === EServiceSign.GasStation);

    const icons: JSX.Element[] = [];

    const formatDate = (dateString: string) => {
        const date = new Date(dateString);
        const day = date.getUTCDate().toString().padStart(2, '0');
        const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
        const year = date.getUTCFullYear();
        return `${day}.${month}.${year}`;
    };

    const finishDate = rentBase?.finish_date ? formatDate(rentBase.finish_date) : '';

    if (rentBase && gasStation && !rentNomenclature) {
        icons.push(
            <Tooltip
                key="gasStation"
                title={
                    <>
                        АЗС
                        {finishDate && (
                            <>
                                <br />
                                Необходимо перейти на другой тариф до {finishDate}
                            </>
                        )}
                    </>
                }
            >
                <Stack direction="row" spacing={0.5} alignItems="center">
                    <WarningAmberIcon fontSize="small" color="warning" />
                    <LocalGasStationOutlinedIcon color="warning" />
                </Stack>
            </Tooltip>,
        );
    } else if (rentBase && gasStation) {
        icons.push(
            <Tooltip
                key="gasStation"
                title={
                    <>
                        АЗС
                        {finishDate && (
                            <>
                                <br />
                                Действует до {finishDate}
                            </>
                        )}
                    </>
                }
            >
                <LocalGasStationOutlinedIcon color="disabled" />
            </Tooltip>,
        );
    } else if (rentBase && !rentNomenclature) {
        icons.push(
            <Tooltip
                key="baseRent"
                title={
                    <>
                        Прокси
                        <br />
                        Связь кассы с ПОРТall и передача чеков в любой ОФД
                        <br />
                        1015 ₸/мес с НДС
                    </>
                }
            >
                <CloudOutlinedIcon color="disabled" />
            </Tooltip>,
        );
    }

    if (rentNomenclature) {
        icons.push(
            <Tooltip
                key="nomenclature"
                title={
                    <>
                        Номенклатура
                        <br />
                        Работа с национальным каталогом товаров и кабинетом номенклатуры
                    </>
                }
            >
                <Inventory2OutlinedIcon color="disabled" />
            </Tooltip>,
        );
    }

    if (rentPremiumOFD) {
        icons.push(
            <Tooltip
                key="premiumOFD"
                title={
                    <>
                        Премиум ОФД
                        <br />С 01.10.2026 входит в тариф «Прокси», отдельно не оплачивается и скоро будет убран
                    </>
                }
            >
                <ReceiptLongOutlinedIcon color="disabled" sx={{opacity: 0.35}} />
            </Tooltip>,
        );
    }

    if (!icons.length) {
        icons.push(
            kkm.service_rent.length ? (
                <Tooltip
                    key="baseRent"
                    title={
                        <>
                            Прокси
                            <br />
                            Связь кассы с ПОРТall и передача чеков в любой ОФД
                            <br />
                            1015 ₸/мес с НДС
                        </>
                    }
                >
                    <CloudOutlinedIcon color="disabled" />
                </Tooltip>
            ) : (
                <Tooltip key="warning" title="Тариф не подключён. Работа кассы может быть ограничена.">
                    <WarningAmberIcon fontSize="small" color="warning" />
                </Tooltip>
            ),
        );
    }

    return <>{icons}</>;
};

export default ServiceRentIcon;
